import { useTranslation } from 'react-i18next';

export default function LendingStepsSection() {
  const { t } = useTranslation();
  
  return (
    <section className="py-16 bg-gray-900" id="start">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('lending.steps.title')}
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-8">
          <div className="bg-gray-800 rounded-2xl p-8 border border-gray-700">
            <div className="text-center mb-6">
              <div className="inline-flex items-baseline gap-2 text-green-400 font-bold mb-4">
                <span className="text-5xl">3</span>
                <span className="text-2xl">{t('lending.steps.subtitle')}</span>
              </div>
            </div>

            <div className="space-y-8">
              {/* Step 1 */}
              <div className="flex flex-col md:flex-row items-center gap-6">
                <div className="flex-shrink-0">
                  <div className="w-24 h-24 rounded-full bg-gradient-to-br from-green-500 to-teal-500 flex items-center justify-center">
                    <i className="ri-user-add-line text-4xl text-white"></i>
                  </div>
                </div>
                <div className="flex-1 text-center md:text-left">
                  <div className="inline-block bg-green-500/20 text-green-400 px-4 py-1 rounded-full text-sm font-semibold mb-3">
                    STEP.01
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">
                    {t('lending.steps.step1.title')}
                  </h3>
                  <p className="text-gray-400">
                    {t('lending.steps.step1.desc')}
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex flex-col md:flex-row items-center gap-6">
                <div className="flex-shrink-0">
                  <div className="w-24 h-24 rounded-full bg-gradient-to-br from-green-500 to-teal-500 flex items-center justify-center">
                    <i className="ri-shield-check-line text-4xl text-white"></i>
                  </div>
                </div>
                <div className="flex-1 text-center md:text-left">
                  <div className="inline-block bg-green-500/20 text-green-400 px-4 py-1 rounded-full text-sm font-semibold mb-3">
                    STEP.02
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">
                    {t('lending.steps.step2.title')}
                  </h3>
                  <p className="text-gray-400">
                    {t('lending.steps.step2.desc')}
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex flex-col md:flex-row items-center gap-6">
                <div className="flex-shrink-0">
                  <div className="w-24 h-24 rounded-full bg-gradient-to-br from-green-500 to-teal-500 flex items-center justify-center">
                    <i className="ri-wallet-3-line text-4xl text-white"></i>
                  </div>
                </div>
                <div className="flex-1 text-center md:text-left">
                  <div className="inline-block bg-green-500/20 text-green-400 px-4 py-1 rounded-full text-sm font-semibold mb-3">
                    STEP.03
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">
                    {t('lending.steps.step3.title')}
                  </h3>
                  <p className="text-gray-400">
                    {t('lending.steps.step3.desc')}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center">
            <button
              className="inline-block bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Get Started Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
